import { apiClient } from '@services/api-client'

import {
  settlementsUrl,
  useSettlementMutation
} from './useSettlementMutation'
import type { CostItemWrite, SettlementCostItem } from '../types'

export function useCreateCostItem() {
  return useSettlementMutation<
    { id: string; body: CostItemWrite },
    SettlementCostItem
  >({
    toastKey: 'settlementCostItemCreated',
    request: async ({ id, body }) =>
      (
        await apiClient.post<SettlementCostItem>(
          `${settlementsUrl}/${id}/cost-items`,
          body
        )
      ).data
  })
}

export function useUpdateCostItem() {
  return useSettlementMutation<
    { id: string; itemId: string; body: Partial<CostItemWrite> },
    SettlementCostItem
  >({
    toastKey: 'settlementCostItemUpdated',
    request: async ({ id, itemId, body }) =>
      (
        await apiClient.patch<SettlementCostItem>(
          `${settlementsUrl}/${id}/cost-items/${itemId}`,
          body
        )
      ).data
  })
}

export function useDeleteCostItem() {
  return useSettlementMutation<{ id: string; itemId: string }, void>({
    toastKey: 'settlementCostItemDeleted',
    request: async ({ id, itemId }) => {
      await apiClient.delete(`${settlementsUrl}/${id}/cost-items/${itemId}`)
    }
  })
}
